module.exports = __webpack_public_path__ + "img/whiteRightArrow.57fe4394.svg";